import { Controller, useForm } from 'react-hook-form';
import Input, { InputSelectOption } from 'src/components/Input/Input';
import { formResolver } from 'src/utils/formResolver';
import { object } from 'yup';
import { booleanScheme, stringScheme } from 'src/utils/validation-schemes';
import type { AnalyticsTeamMember } from 'src/pages/AnalyticsPage/AnalyticsAgent/analyticsAgent.types';

interface AnalyticsTeamMultiSelectProps {
  options: AnalyticsTeamMember[];
  values: AnalyticsTeamMember[];
  // Picking 'Team' clears the members; picking a member drops 'Team'.
  onChange?: (selected: AnalyticsTeamMember[]) => void;
  onClose?: (selected: InputSelectOption[]) => void;
}

export const AnalyticsTeamMultiSelect = ({
  onClose,
  values,
  onChange,
  options,
}: AnalyticsTeamMultiSelectProps) => {
  const { control, trigger } = useForm({
    defaultValues: {
      team: [options[0]],
    },
    resolver: formResolver(
      object({
        team: object({
          label: stringScheme({ required: true }),
          disabled: booleanScheme(),
        }),
      }),
    ),
  });

  return (
    <div className={'input-container md:min-w-52 text-[.88rem]'}>
      <Controller
        control={control}
        name="team"
        render={({ field: { value }, fieldState: { error } }) => (
          <Input
            type={'multi-select'}
            selectOptions={options}
            invalidMessage={error?.message}
            value={values}
            isValid={!error?.message}
            onChange={(selectedOptions, option, checked) => {
              let options: InputSelectOption[] = [];
              if (checked && option.label === 'Team') {
                options = [option];
              } else {
                options = selectedOptions.filter((opt) => opt.label !== 'Team');
              }
              // Input reports back the team members passed in as options.
              onChange?.(options as AnalyticsTeamMember[]);
            }}
            onClose={onClose}
            onBlur={() => trigger('team')}
          />
        )}
      />
    </div>
  );
};
